import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";


type CourseResponse  = {
    id: string;
    createdAt: string;
    updatedAt: string;
    name: string;
    description: string;
    part: string;
    googleForm: string;
    startDate:string;
    isLive:boolean;
    InstructorId: string;
    img_url: string;
    num_hours: string;
    actualPrice_egp: string;
    actualPrice_usd: string;
    preview_video: string;
    categoryId: string;
    isTrending: boolean;
    isAvailable: boolean;
} & ApiError;

export const EditOfflineCourse = (data: CourseResponse , id:string): Promise<CourseResponse> => {
    return axios.patch(`/offline-course/${id}`, data)
        .then(response => response.data as CourseResponse);
};